<script setup>
import { cn } from "@/lib/utils";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <div
    :class="cn('vf-animate-pulse vf-rounded-md vf-bg-neutral-200', props.class)"
  />
</template>
